'use client'

import { useSearch } from './use-search'

import Button from '@/components/ui/button'
import { IconButton } from '@/components/ui/icon-button'
import { Text } from '@/components/ui/text'
import { Flex } from '@/styled-system/jsx'

import CloseIcon from '@/components/icons/close'

type ChipProps = {
  label: string
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
  onDelete?: (event: React.MouseEvent<HTMLButtonElement>) => void
}

function Chip({ label, onClick, onDelete }: ChipProps) {
  const handleDeleteIconClick = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation()
    if (onDelete) {
      onDelete(event)
    }
  }

  return (
    <Flex
      className='group'
      align='center'
      border='1px solid'
      borderColor='#251929'
      borderRadius='sm'
      color='#AD9FB6'
      cursor='pointer'
      gap='1'
      ps='2.5'
      pe='1'
      h='7'
      transitionDuration='normal'
      transitionProperty='border-color, color, background-color'
      transitionTimingFunction='default'
      _hover={{
        bgColor: '#201523',
        borderColor: 'primary',
        color: '#CEBFD9',
      }}
      onClick={onClick}
    >
      <Text as='span' color='inherit' fontWeight='semibold' textStyle='sm'>
        {label}
      </Text>

      <IconButton
        variant='unstyled'
        size='3xs'
        color='inherit'
        _groupHover={{
          color: 'primary',

          _disabled: {
            color: '#AD9FB6!',
          },
        }}
        onClick={handleDeleteIconClick}
        disabled={!onDelete}
      >
        <CloseIcon
          color='inherit'
          size='sm'
          transitionDuration='normal'
          transitionProperty='color'
          transitionTimingFunction='default'
        />
      </IconButton>
    </Flex>
  )
}

export default function SearchRecentSearchs() {
  const {
    history,
    setQuery,
    setInputValue,
    onClearRecents,
    removeFromRecents,
  } = useSearch()

  const onHighlightChange = (value: string) => {
    setQuery(value)
    setInputValue(value)
  }

  if (history.length === 0) return null

  return (
    <Flex direction='column' flex={1} gap={4}>
      <Flex align='center' justify='space-between' minH='6'>
        <Text as='span' color='#CEBFD9' fontWeight='bold' textStyle='sm'>
          Recent searchs
        </Text>
        {history?.length ? (
          <Button
            variant='unstyled'
            size='3xs'
            color='primary'
            fontWeight='bold'
            onClick={onClearRecents}
          >
            CLEAR SEARCH ({history.length})
          </Button>
        ) : null}
      </Flex>

      <Flex align='center' flexWrap='wrap' gap='2.5' minW='10'>
        {history.map((tag, index) => {
          return (
            <Chip
              key={index}
              label={tag}
              onClick={() => onHighlightChange(tag)}
              onDelete={() => removeFromRecents(tag)}
            />
          )
        })}
      </Flex>
    </Flex>
  )
}
